module.exports = __webpack_public_path__ + "static/media/IMG_7992.ddb49b00.JPG";